import loadable from '@loadable/component';
import { OverlaySpinner } from '@ankr.com/ui';
import { Navigate } from 'react-router';

import { LoggingInGuard } from 'modules/auth/components/LoggingInGuard';
import { NoSSRGuard } from 'modules/common/components/NoSSRGuard';
import { Page } from 'modules/layout/components/Page';
import { chainsRoutesConfig } from 'domains/chains/routes';
import { useTeamAccountsQuery } from 'modules/teamAccount/actions/hooks/useTeamAccountsQuery';

const TeamsPage = loadable(
  async () => {
    const module = await import('./TeamsPage');

    return module.TeamsPage;
  },
  {
    fallback: <OverlaySpinner />,
  },
);

const chainsPath = chainsRoutesConfig.chains.generatePath();

function TeamsPageLoader() {
  const { initialLoading: isLoading } = useTeamAccountsQuery({
    skipFetching: false,
  });

  if (isLoading) {
    return <OverlaySpinner />;
  }

  return <TeamsPage />;
}

export const TeamsPageContainer = () => {
  return (
    <Page>
      <NoSSRGuard>
        <LoggingInGuard fallback={<Navigate to={chainsPath} />}>
          <TeamsPageLoader />
        </LoggingInGuard>
      </NoSSRGuard>
    </Page>
  );
};
